import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = function (data, aplicativoDados) {
    try {
        if (data.message == "Network Error") {
            return "Verifique sua conexão!"
            // return 'Sem Internet ou sistema fora do ar!'
        } else if (data.message) {
            return "Erro: " + data.message
        }
        return false
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
    }
}

export const ComumCep = async function (data, appNome) {
    try {
        const response = await api
            .get("comum/Cep/" + data, {
                headers: { "Content-Type": "application/json", app: appNome },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "ComumCep")
    } catch (error) {
        RegistrarLogErro(error, "ComumCep", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const CumumBairros = async function (data, appNome) {
    try {
        const response = await api
            .post("comum/Bairros", data, {
                headers: { "Content-Type": "application/json", app: appNome },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "CumumBairros")
    } catch (error) {
        RegistrarLogErro(error, "CumumBairros", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const CidadesAtendidasPorAplicativo = async function (data, aplicativoDados) {
    try {
        const response = await api
            .post("comum/CidadesAtendidasPorAplicativo", data, {
                headers: { "Content-Type": "application/json", app: data.appNome },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "CidadesAtendidasPorAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "CidadesAtendidasPorAplicativo", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const pegarFaturasEmAberto = async idEstabelecimento => {
    try {
        const response = await api.get(`comum/faturasemaberto/${idEstabelecimento}`, {
            headers: { "Content-Type": "application/json" },
        })

        return tratamentoResponse(response)
    } catch (error) {
        RegistrarLogErro(error, "CidadesAtendidasPorAplicativo")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const getFatura = async idFatura => {
    try {
        const response = await api.get(`comum/fatura/${idFatura}`, {
            headers: { "Content-Type": "application/json" },
        })

        return tratamentoResponse(response)
    } catch (error) {
        RegistrarLogErro(error, "CidadesAtendidasPorAplicativo")
        return { retornoErro: 1, mensagem: error.message }
    }
}

/**
 * Um único "Basic <credencial>" para o header Authorization.
 * Corrige: "Basic Basic …"; e valores fundidos como
 * "Basic xxx, Basic xxx" (dois headers iguais virando um só com vírgula).
 */
function normalizePainelAuthorizationHeader(raw) {
    if (raw == null) return ""
    let s = String(raw).trim()
    const parts = s.split(/\s*,\s*/).filter(Boolean)
    if (parts.length > 1 && /^Basic\s+/i.test(parts[0])) {
        const todasBasic = parts.every(p => /^Basic\s+/i.test(p.trim()))
        if (todasBasic) s = parts[0].trim()
    }
    while (/^Basic\s+Basic\s+/i.test(s)) {
        s = s.replace(/^Basic\s+/i, "")
    }
    return s
}

function dadosWhatsappOficialFromPayload(data) {
    if (data == null || typeof data !== "object") return null
    const inner = data.data != null && typeof data.data === "object" ? data.data : data
    const rawToken =
        inner.token ??
        inner.authorization ??
        inner.Authorization ??
        inner.accessToken ??
        inner.bearer ??
        ""
    const token =
        rawToken == null || rawToken === ""
            ? ""
            : String(rawToken).replace(/^Bearer\s+/i, "").trim()
    const wabaid = inner.wabaid != null ? String(inner.wabaid).trim() : ""
    return {
        token,
        wabaid,
        conta: inner.conta != null ? String(inner.conta) : "",
        telefone: inner.telefone != null ? String(inner.telefone) : "",
        ativo: inner.ativo === true,
    }
}

export const getWhatsappOficialAuthorization = async (idEstabelecimento, authorization) => {
    const authHeader = normalizePainelAuthorizationHeader(authorization)
    try {
        const response = await api.get(`comum/whatsapp/oficial/${idEstabelecimento}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: authHeader,
            },
        })

        return tratamentoResponse(response, "getWhatsappOficialAuthorization")
    } catch (error) {
        RegistrarLogErro(error, "getWhatsappOficialAuthorization", idEstabelecimento)
        if (error.response && error.response.status === 404) {
            return {
                retornoErro: 404,
                mensagem: "Não há configuração WhatsApp oficial para este estabelecimento.",
            }
        }
        return { retornoErro: 1, mensagem: error.message }
    }
}

/**
 * Config WhatsApp Cloud API: token Graph + wabaid (phone_number_id na URL /messages).
 * Header da sessão: authorization (token do painel).
 * @returns {Promise<
 *   | { ok: true, token: string, wabaid: string, conta: string, telefone: string, ativo: boolean }
 *   | { ok: false, mensagem: string }
 * >}
 */
export const buscarTokenWhatsappOficial = async (idEstabelecimento, authorization) => {
    const data = await getWhatsappOficialAuthorization(idEstabelecimento, authorization)
    if (data.retornoErro) {
        return {
            ok: false,
            mensagem: data.mensagem || "Erro ao buscar autorização do WhatsApp oficial",
        }
    }
    const parsed = dadosWhatsappOficialFromPayload(data)
    if (!parsed || !parsed.token) {
        return { ok: false, mensagem: "Resposta sem token de autorização." }
    }
    if (!parsed.wabaid) {
        return { ok: false, mensagem: "Resposta sem wabaid (ID para envio na Graph API)." }
    }
    return {
        ok: true,
        token: parsed.token,
        wabaid: parsed.wabaid,
        conta: parsed.conta,
        telefone: parsed.telefone,
        ativo: parsed.ativo,
    }
}
